import { render } from "./foot.vue?vue&type=template&id=2fcc7856&scoped=true"
const script = {}

import "./foot.vue?vue&type=style&index=0&id=2fcc7856&lang=scss&scoped=true"

import exportComponent from "D:\\Leo\\Frontend\\surveys\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcc7856"]])

export default __exports__